export const ALL = "__ALL__";
export const CLASS_ORDER = ["I", "a II-a", "a III-a", "a IV-a", "a V-a", "a VI-a", "a VII-a", "a VIII-a"];
export const LANG_ORDER = ["Română", "Engleză", "Franceză"];

export function uniqueSorted(values: string[], order?: string[]): string[] {
  const set = [...new Set(values)];
  if (order) {
    return set.sort((a, b) => {
      const ia = order.indexOf(a);
      const ib = order.indexOf(b);
      if (ia === -1 && ib === -1) return a.localeCompare(b, "ro");
      if (ia === -1) return 1;
      if (ib === -1) return -1;
      return ia - ib;
    });
  }
  return set.sort((a, b) => a.localeCompare(b, "ro"));
}

export type FilterValues = Record<string, string>;

/**
 * Options for one filter field, restricted to items that match every OTHER
 * currently-active filter (so picking a class narrows which disciplines/
 * languages/publishers show up, and vice versa). The currently-selected
 * value for `field` is always included even if it would otherwise be
 * excluded, so the <select> never shows a value with no matching <option>.
 */
export function cascadingOptions(
  items: Record<string, string>[],
  active: FilterValues,
  field: string,
  order?: string[],
): string[] {
  const relevant = items.filter((item) =>
    Object.keys(active).every((key) => key === field || active[key] === ALL || item[key] === active[key]),
  );
  const options = uniqueSorted(
    relevant.map((item) => item[field]).filter((v): v is string => v !== undefined),
    order,
  );
  const current = active[field];
  if (current !== undefined && current !== ALL && !options.includes(current)) options.push(current);
  return options;
}
